import logo from './logo.svg';
import './App.css';
import AppRouters from './core/AppRouters';
import { ToastContainer } from 'react-toastify';
import { useTranslate } from './core';

function App() {
  useTranslate();
  return (
    <>

    <AppRouters/>
    <ToastContainer/>
    </>
  );
}

export default App;
